import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="alerts-toggle"
export default class extends Controller {

  static targets = ['modal', 'btn']

  connect() {
    document.addEventListener('click', (e) => {
      if(!this.btnTarget.contains(e.target) && !this.modalTarget.contains(e.target) ){
        this.close();
      }
    })
  }

  toggle() {
    this.modalTarget.classList.toggle('open');
  }

  close() {
    this.modalTarget.classList.remove('open');
  }
}
